import React from 'react';
import { Box } from '@availity/element';
import PropTypes from 'prop-types';
import { colors } from '../../../static/constants/theme';

const StatisticCard = ({ value, label, responsive = true }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '2px',
      borderRadius: '16px',
    }}
  >
    <Box
      sx={{
        alignSelf: 'stretch',
        textAlign: 'center',
        color: colors.text.light,
        fontSize: responsive ? { xs: 24, md: 32 } : 32,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        lineHeight: responsive ? { xs: '38px', md: '38px' } : '38px',
      }}
    >
      {value}
    </Box>
    <Box
      sx={{
        alignSelf: 'stretch',
        textAlign: 'center',
        color: colors.white,
        fontSize: responsive ? { xs: 16, md: 16 } : 16,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        lineHeight: responsive ? { xs: '22px', md: '22px' } : '22px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  </Box>
);

StatisticCard.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  responsive: PropTypes.bool,
};

export default StatisticCard;